import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { firestore } from '../firebase';
import { dateFormatter } from '../helpers/dateFormatter';
import StateContext from '../StateContext';

function TransferPage() {

    const appState = useContext(StateContext)
    const [transfers, setTransfers] = useState([]);

    useEffect(() => {

        try {
            const transfersRef = firestore.collection("transfers");
            transfersRef.onSnapshot(({docs}) => {
                const transfers = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setTransfers(transfers);
            })
        } catch (error) {
            
        }

    }, [])

    return (
        <div className="container my-4">
            {appState.loggedIn && (
                <Link to="/add-transfer" className="btn btn-success my-3"><i className="fas fa-plus"></i> Ny overgang</Link>
            )}
            <div className="row">
                {transfers?.map((transfer, index) => {
                    return (
                        <div key={index} className="col-md-4 col-lg-4 my-4" style={{fontSize: "0.9rem"}}>
                            <div className="card card-body">
                                <div className="row">
                                    <div className="col-2">
                                        <img src={transfer.image} alt={transfer.player_name} className="img-fluid rounded-circle" />
                                    </div> 
                                    <div className="col-7">
                                        <p className="font-weight-bold">{transfer.player_name}</p>
                                        <p><i className="fas fa-arrow-right text-success"></i> {transfer.to_club_name} </p>
                                        <p><i className="fas fa-arrow-left text-danger"></i> {transfer.from_club_name} </p>
                                        <p className="text-muted">Sum: €{transfer.transfer_sum}m</p>
                                    </div> 
                                    <div className="col-3">
                                        <small className="text-muted">{dateFormatter(transfer.date)}</small>
                                    </div>
                                    {appState.loggedIn && (
                                        <div className="col-12">
                                            <span className="float-right">
                                                <Link to={`/edit-transfer/${transfer.id}`}><i className="fas fa-edit"></i></Link>
                                            </span>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
export default TransferPage